import React, { useEffect } from "react";
import AllForzenFoods from "../ForzenFoods/AllForzenFoods";
import Header from "../Home/Header";
import Footer from "../Footer/Footer";
const ForzenFoods = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <Header />
      <AllForzenFoods/>
      <Footer />
    </>
  );
};

export default ForzenFoods;
